import en from './en.json';
import ar from './ar.json';
import ar_SA from './ar-sa.json';

export default { en, ar, 'ar-SA': ar_SA };
